import { Document } from "@react-pdf/renderer";
import { GrupoPorLocal } from "../components/agruparPorDefensoriaNucleo";
import { RMovimentoDto } from "@/api.types";
import { ReportPageDefender } from "./ReportPageDefender";
import { ReportPageDefense } from "./ReportPageDefense";
import { ResumoPage, ResumoPageDefensoriaMovimentos } from "./ReportPageSummary";
import { calcularResumoPorTipo, calcularResumoPorDefensor, calcularResumoPorDefensoria, calcularResumoPorDefensoriaETipoMovimento } from "../movimentacao.service";
import { parametrosRelatorioMovimentacoes } from "../components/ModalFiltrosMovimentacoes";

interface IMyProps {
  dados: RMovimentoDto[];
  dadosAgrupadosPorLocal?: GrupoPorLocal[];
  parametros: parametrosRelatorioMovimentacoes
  printResumoDefensoria?: boolean
  printResumoDefensor?: boolean
  printResumoTipo?: boolean
  printResumoDefensoriaAgrupado?: boolean
  printResumoDefensoriaDetalhado?: boolean
  printResumoDefensorDetalhado?: boolean
}

export function RelatorioPDFMovimentacoes(
  {
    dados,
    dadosAgrupadosPorLocal,
    parametros,
    printResumoDefensoria,
    printResumoDefensor,
    printResumoTipo,
    printResumoDefensoriaAgrupado,
    printResumoDefensoriaDetalhado,
    printResumoDefensorDetalhado
  }: IMyProps) {

  const resumoTipo = calcularResumoPorTipo(dados).sort((a, b) => a.tipo ? a.tipo.localeCompare(b.tipo) : 0);
  const resumoDefensor = calcularResumoPorDefensor(dados).sort((a, b) => a.tipo ? a.tipo.localeCompare(b.tipo) : 0);
  const resumoDefensoria = calcularResumoPorDefensoria(dados).sort((a, b) => a.tipo ? a.tipo.localeCompare(b.tipo) : 0);
  const resumoDefensoriaETipo = calcularResumoPorDefensoriaETipoMovimento(dados);

  return (
    <Document>
      {printResumoDefensoria && <ResumoPage data={resumoDefensoria} label="Defensoria" parametros={parametros} />}
      {printResumoDefensor && <ResumoPage data={resumoDefensor} label="Defensor" parametros={parametros} />}
      {printResumoTipo && <ResumoPage data={resumoTipo} label="Tipo" parametros={parametros} />}
      {printResumoDefensoriaAgrupado && <ResumoPageDefensoriaMovimentos data={resumoDefensoriaETipo} parametros={parametros} />}

      {printResumoDefensoriaDetalhado && dadosAgrupadosPorLocal && <ReportPageDefense dados={dadosAgrupadosPorLocal} parametros={parametros} />}
      {printResumoDefensorDetalhado && <ReportPageDefender dados={dados} parametros={parametros} />}
    </Document>
  );
}
